import {
  SEARCH_SINGLE_CUSTOMER_OPPORTUNITIES_LIST,
  SEARCH_SINGLE_CUSTOMER_OPPORTUNITIES_LIST_SUCCESS,
  SEARCH_SINGLE_CUSTOMER_OPPORTUNITIES_LIST_FAIL,
  CREATE_OPPORTUNITIES_ITEM,
  CREATE_OPPORTUNITIES_ITEM_SUCCESS,
  CREATE_OPPORTUNITIES_ITEM_FAIL,
  UPDATE_OPPORTUNITIES_ITEM,
  UPDATE_OPPORTUNITIES_ITEM_SUCCESS,
  UPDATE_OPPORTUNITIES_ITEM_FAIL,
  GET_ALL_OPPORTUNITIES_LIST,
  GET_ALL_OPPORTUNITIES_LIST_SUCCESS,
  GET_ALL_OPPORTUNITIES_LIST_FAIL,
  GET_SINGLE_OPPORTUNITIES_ITEM,
  GET_SINGLE_OPPORTUNITIES_ITEM_SUCCESS,
  GET_SINGLE_OPPORTUNITIES_ITEM_FAIL,
  DELETE_OPPORTUNITIES_ITEM,
  DELETE_OPPORTUNITIES_ITEM_SUCCESS,
  DELETE_OPPORTUNITIES_ITEM_FAIL,
  OPPORTUNITIES_STATUS_LIST,
  OPPORTUNITIES_STATUS_LIST_SUCCESS,
  OPPORTUNITIES_STATUS_LIST_FAIL,
  OPPORTUNITIES_PRIORITY_LIST,
  OPPORTUNITIES_PRIORITY_LIST_SUCCESS,
  OPPORTUNITIES_PRIORITY_LIST_FAIL,
  OPPORTUNITIES_TYPE_LIST,
  OPPORTUNITIES_TYPE_LIST_SUCCESS,
  OPPORTUNITIES_TYPE_LIST_FAIL,
  GET_SINGLE_OPPORTUNITY_DATA,
  GET_SINGLE_OPPORTUNITY_DATA_SUCCESS,
  GET_SINGLE_OPPORTUNITY_DATA_FAIL,
  SEARCH_OPPORTUNITY_NOTE_LIST,
  SEARCH_OPPORTUNITY_NOTE_LIST_SUCCESS,
  SEARCH_OPPORTUNITY_NOTE_LIST_FAIL,
  CREATE_OPPORTUNITY_NOTE_ITEM,
  CREATE_OPPORTUNITY_NOTE_ITEM_SUCCESS,
  CREATE_OPPORTUNITY_NOTE_ITEM_FAIL,
  SINGLE_OPPORTUNITY_ACTIVITY_LIST,
  SINGLE_OPPORTUNITY_ACTIVITY_LIST_SUCCESS,
  SINGLE_OPPORTUNITY_ACTIVITY_LIST_FAIL,
  ADD_NEW_OPPORTUNITY_STATUS,
  ADD_NEW_OPPORTUNITY_STATUS_SUCCESS,
  ADD_NEW_OPPORTUNITY_STATUS_FAIL,
  DELETE_OPPORTUNITY_STATUS,
  DELETE_OPPORTUNITY_STATUS_SUCCESS,
  DELETE_OPPORTUNITY_STATUS_FAIL,
  UPDATE_OPPORTUNITY_STATUS,
  UPDATE_OPPORTUNITY_STATUS_SUCCESS,
  UPDATE_OPPORTUNITY_STATUS_FAIL,
  ADD_NEW_OPPORTUNITY_PRIORITY,
  ADD_NEW_OPPORTUNITY_PRIORITY_SUCCESS,
  ADD_NEW_OPPORTUNITY_PRIORITY_FAIL,
  DELETE_OPPORTUNITY_PRIORITY,
  DELETE_OPPORTUNITY_PRIORITY_SUCCESS,
  DELETE_OPPORTUNITY_PRIORITY_FAIL,
  UPDATE_OPPORTUNITY_PRIORITY,
  UPDATE_OPPORTUNITY_PRIORITY_SUCCESS,
  UPDATE_OPPORTUNITY_PRIORITY_FAIL,
  ADD_NEW_OPPORTUNITY_TYPE,
  ADD_NEW_OPPORTUNITY_TYPE_SUCCESS,
  ADD_NEW_OPPORTUNITY_TYPE_FAIL,
  DELETE_OPPORTUNITY_TYPE,
  DELETE_OPPORTUNITY_TYPE_SUCCESS,
  DELETE_OPPORTUNITY_TYPE_FAIL,
  UPDATE_OPPORTUNITY_TYPE,
  UPDATE_OPPORTUNITY_TYPE_SUCCESS,
  UPDATE_OPPORTUNITY_TYPE_FAIL,
  GET_OPPORTUNITY_OVERVIEW_FUNNEL_DATA,
  GET_OPPORTUNITY_OVERVIEW_FUNNEL_DATA_SUCCESS,
  GET_OPPORTUNITY_OVERVIEW_FUNNEL_DATA_FAIL,
  SEARCH_OPPORTUNITY_ATTACHMENT_LIST,
  SEARCH_OPPORTUNITY_ATTACHMENT_LIST_SUCCESS,
  SEARCH_OPPORTUNITY_ATTACHMENT_LIST_FAIL,
  DELETE_OPPORTUNITY_ATTACHMENT,
  DELETE_OPPORTUNITY_ATTACHMENT_SUCCESS,
  DELETE_OPPORTUNITY_ATTACHMENT_FAIL,
  SEARCH_OPPORTUNITY_PRODUCT_LIST,
  SEARCH_OPPORTUNITY_PRODUCT_LIST_SUCCESS,
  SEARCH_OPPORTUNITY_PRODUCT_LIST_FAIL,
  CREATE_OPPORTUNITY_PRODUCT_ITEM,
  CREATE_OPPORTUNITY_PRODUCT_ITEM_SUCCESS,
  CREATE_OPPORTUNITY_PRODUCT_ITEM_FAIL,
  DELETE_OPPORTUNITY_PRODUCT_ITEM,
  DELETE_OPPORTUNITY_PRODUCT_ITEM_SUCCESS,
  DELETE_OPPORTUNITY_PRODUCT_ITEM_FAIL,
} from "./actionType";

// Opportunity List Action
export const searchSingleCustomerOpportunitiesList = (data) => ({
  type: SEARCH_SINGLE_CUSTOMER_OPPORTUNITIES_LIST,
  payload: data,
});

export const searchSingleCustomerOpportunitiesListSuccess = (data) => ({
  type: SEARCH_SINGLE_CUSTOMER_OPPORTUNITIES_LIST_SUCCESS,
  payload: data,
});

export const searchSingleCustomerOpportunitiesListFail = (data) => ({
  type: SEARCH_SINGLE_CUSTOMER_OPPORTUNITIES_LIST_FAIL,
  payload: data,
});

// Create Opportunity Action
export const createOpportunitiesItem = (data) => ({
  type: CREATE_OPPORTUNITIES_ITEM,
  payload: data,
});

export const createOpportunitiesItemSuccess = (data) => ({
  type: CREATE_OPPORTUNITIES_ITEM_SUCCESS,
  payload: data,
});

export const createOpportunitiesItemFail = (data) => ({
  type: CREATE_OPPORTUNITIES_ITEM_FAIL,
  payload: data,
});

// Update Opportunity Action
export const updateOpportunitiesItem = (data) => ({
  type: UPDATE_OPPORTUNITIES_ITEM,
  payload: data,
});

export const updateOpportunitiesItemSuccess = (data) => ({
  type: UPDATE_OPPORTUNITIES_ITEM_SUCCESS,
  payload: data,
});

export const updateOpportunitiesItemFail = (data) => ({
  type: UPDATE_OPPORTUNITIES_ITEM_FAIL,
  payload: data,
});

// Get All Opportunity List Action
export const getAllOpportunitiesList = () => ({
  type: GET_ALL_OPPORTUNITIES_LIST,
});

export const getAllOpportunitiesListSuccess = (data) => ({
  type: GET_ALL_OPPORTUNITIES_LIST_SUCCESS,
  payload: data,
});

export const getAllOpportunitiesListFail = (data) => ({
  type: GET_ALL_OPPORTUNITIES_LIST_FAIL,
  payload: data,
});

// Get Single Opportunity Item Action

export const getSingleOpportunitiesItem = (data) => ({
  type: GET_SINGLE_OPPORTUNITIES_ITEM,
  payload: data,
});

export const getSingleOpportunitiesItemSuccess = (data) => ({
  type: GET_SINGLE_OPPORTUNITIES_ITEM_SUCCESS,
  payload: data,
});

export const getSingleOpportunitiesItemFail = (data) => ({
  type: GET_SINGLE_OPPORTUNITIES_ITEM_FAIL,
  payload: data,
});

// Delete Opportunity Item Action
export const deleteOpportunitiesItem = (data) => ({
  type: DELETE_OPPORTUNITIES_ITEM,
  payload: data,
});

export const deleteOpportunitiesItemSuccess = (data) => ({
  type: DELETE_OPPORTUNITIES_ITEM_SUCCESS,
  payload: data,
});

export const deleteOpportunitiesItemFail = (data) => ({
  type: DELETE_OPPORTUNITIES_ITEM_FAIL,
  payload: data,
});

// Opportunity Status List Action
export const opportunitiesStatusList = () => ({
  type: OPPORTUNITIES_STATUS_LIST,
});

export const opportunitiesStatusListSuccess = (data) => ({
  type: OPPORTUNITIES_STATUS_LIST_SUCCESS,
  payload: data,
});

export const opportunitiesStatusListFail = (data) => ({
  type: OPPORTUNITIES_STATUS_LIST_FAIL,
  payload: data,
});

// Opportunity Priority List Action
export const opportunitiesPriorityList = () => ({
  type: OPPORTUNITIES_PRIORITY_LIST,
});

export const opportunitiesPriorityListSuccess = (data) => ({
  type: OPPORTUNITIES_PRIORITY_LIST_SUCCESS,
  payload: data,
});

export const opportunitiesPriorityListFail = (data) => ({
  type: OPPORTUNITIES_PRIORITY_LIST_FAIL,
  payload: data,
});

// Opportunity Type List Action
export const opportunitiesTypeList = () => ({
  type: OPPORTUNITIES_TYPE_LIST,
});

export const opportunitiesTypeListSuccess = (data) => ({
  type: OPPORTUNITIES_TYPE_LIST_SUCCESS,
  payload: data,
});

export const opportunitiesTypeListFail = (data) => ({
  type: OPPORTUNITIES_TYPE_LIST_FAIL,
});

// Get Single Opportunity Data Action
export const getSingleOpportunityData = (data) => ({
  type: GET_SINGLE_OPPORTUNITY_DATA,
  payload: data,
});

export const getSingleOpportunityDataSuccess = (data) => ({
  type: GET_SINGLE_OPPORTUNITY_DATA_SUCCESS,
  payload: data,
});

export const getSingleOpportunityDataFail = (data) => ({
  type: GET_SINGLE_OPPORTUNITY_DATA_FAIL,
  payload: data,
});

// Search Opportunity Note List Action

export const searchOpportunityNoteList = (data) => ({
  type: SEARCH_OPPORTUNITY_NOTE_LIST,
  payload: data,
});

export const searchOpportunityNoteListSuccess = (data) => ({
  type: SEARCH_OPPORTUNITY_NOTE_LIST_SUCCESS,
  payload: data,
});

export const searchOpportunityNoteListFail = (data) => ({
  type: SEARCH_OPPORTUNITY_NOTE_LIST_FAIL,
  payload: data,
});

// Create Opportunity Note Item Action

export const createOpportunityNoteItem = (data) => ({
  type: CREATE_OPPORTUNITY_NOTE_ITEM,
  payload: data,
});

export const createOpportunityNoteItemSuccess = (data) => ({
  type: CREATE_OPPORTUNITY_NOTE_ITEM_SUCCESS,
  payload: data,
});

export const createOpportunityNoteItemFail = (data) => ({
  type: CREATE_OPPORTUNITY_NOTE_ITEM_FAIL,
  payload: data,
});

// Single Opportunity Activity List Action

export const singleOpportunityActivityList = (data) => ({
  type: SINGLE_OPPORTUNITY_ACTIVITY_LIST,
  payload: data,
});

export const singleOpportunityActivityListSuccess = (data) => ({
  type: SINGLE_OPPORTUNITY_ACTIVITY_LIST_SUCCESS,
  payload: data,
});

export const singleOpportunityActivityListFail = (data) => ({
  type: SINGLE_OPPORTUNITY_ACTIVITY_LIST_FAIL,
  payload: data,
});

// Add New Opportunity Status Action

export const addNewOpportunityStatus = (data) => ({
  type: ADD_NEW_OPPORTUNITY_STATUS,
  payload: data,
});

export const addNewOpportunityStatusSuccess = (data) => ({
  type: ADD_NEW_OPPORTUNITY_STATUS_SUCCESS,
  payload: data,
});

export const addNewOpportunityStatusFail = (data) => ({
  type: ADD_NEW_OPPORTUNITY_STATUS_FAIL,
  payload: data,
});

// Delete Opportunity Status Action

export const deleteOpportunityStatus = (data) => ({
  type: DELETE_OPPORTUNITY_STATUS,
  payload: data,
});

export const deleteOpportunityStatusSuccess = (data) => ({
  type: DELETE_OPPORTUNITY_STATUS_SUCCESS,
  payload: data,
});

export const deleteOpportunityStatusFail = (data) => ({
  type: DELETE_OPPORTUNITY_STATUS_FAIL,
  payload: data,
});

// Update Opportunity Status Action

export const updateOpportunityStatus = (data) => ({
  type: UPDATE_OPPORTUNITY_STATUS,
  payload: data,
});

export const updateOpportunityStatusSuccess = (data) => ({
  type: UPDATE_OPPORTUNITY_STATUS_SUCCESS,
  payload: data,
});

export const updateOpportunityStatusFail = (data) => ({
  type: UPDATE_OPPORTUNITY_STATUS_FAIL,
  payload: data,
});

// Add New Opportunity Priority Action

export const addNewOpportunityPriority = (data) => ({
  type: ADD_NEW_OPPORTUNITY_PRIORITY,
  payload: data,
});

export const addNewOpportunityPrioritySuccess = (data) => ({
  type: ADD_NEW_OPPORTUNITY_PRIORITY_SUCCESS,
  payload: data,
});

export const addNewOpportunityPriorityFail = (data) => ({
  type: ADD_NEW_OPPORTUNITY_PRIORITY_FAIL,
  payload: data,
});

// Delete Opportunity Priority Action

export const deleteOpportunityPriority = (data) => ({
  type: DELETE_OPPORTUNITY_PRIORITY,
  payload: data,
});

export const deleteOpportunityPrioritySuccess = (data) => ({
  type: DELETE_OPPORTUNITY_PRIORITY_SUCCESS,
  payload: data,
});

export const deleteOpportunityPriorityFail = (data) => ({
  type: DELETE_OPPORTUNITY_PRIORITY_FAIL,
  payload: data,
});

// Update Opportunity Priority Action

export const updateOpportunityPriority = (data) => ({
  type: UPDATE_OPPORTUNITY_PRIORITY,
  payload: data,
});

export const updateOpportunityPrioritySuccess = (data) => ({
  type: UPDATE_OPPORTUNITY_PRIORITY_SUCCESS,
  payload: data,
});

export const updateOpportunityPriorityFail = (data) => ({
  type: UPDATE_OPPORTUNITY_PRIORITY_FAIL,
  payload: data,
});

// Add New Opportunity Type Action

export const addNewOpportunityType = (data) => ({
  type: ADD_NEW_OPPORTUNITY_TYPE,
  payload: data,
});

export const addNewOpportunityTypeSuccess = (data) => ({
  type: ADD_NEW_OPPORTUNITY_TYPE_SUCCESS,
  payload: data,
});

export const addNewOpportunityTypeFail = (data) => ({
  type: ADD_NEW_OPPORTUNITY_TYPE_FAIL,
  payload: data,
});

// Delete Opportunity Type Action

export const deleteOpportunityType = (data) => ({
  type: DELETE_OPPORTUNITY_TYPE,
  payload: data,
});

export const deleteOpportunityTypeSuccess = (data) => ({
  type: DELETE_OPPORTUNITY_TYPE_SUCCESS,
  payload: data,
});

export const deleteOpportunityTypeFail = (data) => ({
  type: DELETE_OPPORTUNITY_TYPE_FAIL,
  payload: data,
});

// Update Opportunity Type Action

export const updateOpportunityType = (data) => ({
  type: UPDATE_OPPORTUNITY_TYPE,
  payload: data,
});

export const updateOpportunityTypeSuccess = (data) => ({
  type: UPDATE_OPPORTUNITY_TYPE_SUCCESS,
  payload: data,
});

export const updateOpportunityTypeFail = (data) => ({
  type: UPDATE_OPPORTUNITY_TYPE_FAIL,
  payload: data,
});

// Get Opportunity Overview Funnel Data Action

export const getOpportunityOverviewFunnelData = (data) => ({
  type: GET_OPPORTUNITY_OVERVIEW_FUNNEL_DATA,
  payload: data,
});

export const getOpportunityOverviewFunnelDataSuccess = (data) => ({
  type: GET_OPPORTUNITY_OVERVIEW_FUNNEL_DATA_SUCCESS,
  payload: data,
});

export const getOpportunityOverviewFunnelDataFail = (data) => ({
  type: GET_OPPORTUNITY_OVERVIEW_FUNNEL_DATA_FAIL,
  payload: data,
});

// Search Opportunity Attachment List Action

export const searchOpportunityAttachmentList = (data) => ({
  type: SEARCH_OPPORTUNITY_ATTACHMENT_LIST,
  payload: data,
});

export const searchOpportunityAttachmentListSuccess = (data) => ({
  type: SEARCH_OPPORTUNITY_ATTACHMENT_LIST_SUCCESS,
  payload: data,
});

export const searchOpportunityAttachmentListFail = (data) => ({
  type: SEARCH_OPPORTUNITY_ATTACHMENT_LIST_FAIL,
  payload: data,
});

// Delete Opportunity Attachment Action

export const deleteOpportunityAttachment = (data) => ({
  type: DELETE_OPPORTUNITY_ATTACHMENT,
  payload: data,
});

export const deleteOpportunityAttachmentSuccess = (data) => ({
  type: DELETE_OPPORTUNITY_ATTACHMENT_SUCCESS,
  payload: data,
});

export const deleteOpportunityAttachmentFail = (data) => ({
  type: DELETE_OPPORTUNITY_ATTACHMENT_FAIL,
  payload: data,
});

// Search Opportunity Product (interested products) List Action

export const searchOpportunityProductList = (data) => ({
  type: SEARCH_OPPORTUNITY_PRODUCT_LIST,
  payload: data,
});

export const searchOpportunityProductListSuccess = (data) => ({
  type: SEARCH_OPPORTUNITY_PRODUCT_LIST_SUCCESS,
  payload: data,
});

export const searchOpportunityProductListFail = (data) => ({
  type: SEARCH_OPPORTUNITY_PRODUCT_LIST_FAIL,
  payload: data,
});

// Create Opportunity Product Item Action

export const createOpportunityProductItem = (data) => ({
  type: CREATE_OPPORTUNITY_PRODUCT_ITEM,
  payload: data,
});

export const createOpportunityProductItemSuccess = (data) => ({
  type: CREATE_OPPORTUNITY_PRODUCT_ITEM_SUCCESS,
  payload: data,
});

export const createOpportunityProductItemFail = (data) => ({
  type: CREATE_OPPORTUNITY_PRODUCT_ITEM_FAIL,
  payload: data,
});

// Delete Opportunity Product Item Action

export const deleteOpportunityProductItem = (data) => ({
  type: DELETE_OPPORTUNITY_PRODUCT_ITEM,
  payload: data,
});

export const deleteOpportunityProductItemSuccess = (data) => ({
  type: DELETE_OPPORTUNITY_PRODUCT_ITEM_SUCCESS,
  payload: data,
});

export const deleteOpportunityProductItemFail = (data) => ({
  type: DELETE_OPPORTUNITY_PRODUCT_ITEM_FAIL,
  payload: data,
});
